/**
 * Modal keyboard handler — global ESC-to-close + Tab focus trap.
 *
 * Sprint 19d (2026-05-09).
 *
 * Поддерживаемые модалки:
 *   - .modal.show         — старые модалки калькулятора (service, catalog, categories-manager)
 *   - [data-modal-overlay] — новые overlay-модалки (catalogs, supplier-form, etc.)
 *
 * ESC закрывает поверх (top-of-stack). Inline-редактирование (input типа text внутри
 * .inline-edit) обрабатывает ESC само — мы проверяем флаг на target.
 */

'use strict';

function getTopModal() {
    // 1. Сначала overlays — у них z-index выше (data-modal-overlay).
    const overlays = document.querySelectorAll('[data-modal-overlay]');
    if (overlays.length > 0) {
        // Берём последний (top of stack).
        return { type: 'overlay', el: overlays[overlays.length - 1] };
    }

    // 2. Потом старые .modal.show.
    const legacy = document.querySelectorAll('.modal.show');
    if (legacy.length > 0) {
        return { type: 'legacy', el: legacy[legacy.length - 1] };
    }

    return null;
}

function closeModal(modal) {
    if (!modal) return;
    if (modal.type === 'overlay') {
        // Если есть data-on-close="callback" — вызовем глобальную функцию
        // (для overlays которые сохраняют state перед закрытием).
        const cb = modal.el.dataset.onClose;
        if (cb && typeof window[cb] === 'function') {
            try { window[cb](); } catch (_) {}
        }
        modal.el.remove();
    } else if (modal.type === 'legacy') {
        modal.el.classList.remove('show');
    }
}

document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    // Не перехватываем ESC в inline-edit — тот сам обрабатывает (revert value).
    const active = document.activeElement;
    if (active) {
        if (active.matches('.inline-edit, .inline-edit *')) return;
        if (active.dataset && active.dataset.escSkip === 'true') return;
        // textarea/Quill/contenteditable обычно ESC должен оставлять fokус полю
        // если пользователь активно редактирует — пусть ESC будет ESC. Но если
        // он не в режиме редактирования значения, закрываем модалку.
        // Простое правило: на input/textarea ESC blur'нет поле, но если уже
        // нет фокуса — закроет модалку.
    }

    const modal = getTopModal();
    if (modal) {
        e.preventDefault();
        closeModal(modal);
    }
}, true);  // capture phase — даём шанс обработать до form-submit handlers

// Export for programmatic close
if (typeof window !== 'undefined') {
    window.closeTopModal = () => {
        const m = getTopModal();
        if (m) closeModal(m);
    };
}
